import { render, staticRenderFns } from "./KPIAdd.vue?vue&type=template&id=53c6debe&"
import script from "./KPIAdd.vue?vue&type=script&lang=js&"
export * from "./KPIAdd.vue?vue&type=script&lang=js&"
import style0 from "./KPIAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports